import {ValidacaoService} from './../../service/validacao.service';
import {FormControl, Validators, FormGroup, FormBuilder, NgForm} from '@angular/forms';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {GlobalService} from './../../service/global.service';
import {ModalService} from './../../service/modal.service';
import {
    FTA,
    Evento,
    EventoPermissoes,
    OrigemPermissoes,
    Cliente,
    InstalacaoProduto,
    DestinoPermissoes,
    Parametro,
    ParametroConteudo,
    ParametroInstalacaoProduto,
    MCI,
    UOR,
    UserAplicacao,
    ItemConfiguracao,
    ItemConfiguracaoProduto,
    ParametroEntradaInstalacaoProduto,
    EventoPrincipal,
    Layout
} from './../../model/catalogo';
import {Component, OnInit, Output, EventEmitter, Input, Injectable, ViewChild, HostListener} from '@angular/core';

import {FtaService} from '../../service/fta.service';
import {WizardComponent} from 'angular-archwizard';
import {JQueryStatic} from 'jquery';
import {FiltroAlteracaoEstado, ResultadoFiltroLayout, FiltroUsuarioAplicacao} from '../../model/filtros';
import {userAplicacao, Usuario, UsuarioPesquisa} from '../../model/usuario';
import {HttpClient} from '@angular/common/http';

declare var $: JQueryStatic;

@Component({
    selector: 'app-detalhe-evento-permissoes',
    templateUrl: './detalhe-evento-permissoes.component.html',
    styleUrls: ['./detalhe-evento-permissoes.component.css'],
    providers: [ValidacaoService]
})


@Injectable()
export class DetalheEventoPermissoesComponent implements OnInit {

    constructor(
        private modalService: ModalService,
        public globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        public ftaService: FtaService,
        public http: HttpClient,
        private validacaoService: ValidacaoService,
        @ViewChild(WizardComponent)
        public wizard: WizardComponent
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.novoEventoPermissoes != undefined && $('#modalEvento').hasClass('in')) {
                this.finishFunction();
            }
        }
    }

    parmPermissoes: Array<Parametro> = new Array<Parametro>();
    permissoes: EventoPermissoes = new EventoPermissoes();

    cliente: Cliente = new Cliente();
    clienteAutorizacaoExtra: Cliente = new Cliente();

    @Output() permissoesAdicionada = new EventEmitter();
    @Output() eventoAlterado = new EventEmitter();
    @Output() eventoCancelado = new EventEmitter();

    @Input() novoEventoPermissoes: EventoPermissoes;
    @Input() evento: Evento;
    @Input() fta: FTA;

    chaveComposta: any;

    usuarioSelecionado: any;

    listaItens: Array<EventoPermissoes> = new Array<EventoPermissoes>();
    listaParametro: Array<Parametro> = new Array<Parametro>();

    nomeSubtipoDado: string;
    eventoSelecionado: boolean = false;
    eventoLocal: Evento;
    selectedRange: any;
    caracteresInvalidos: string = '';

    resultadoUsuario: any;
    pesquisado: boolean = false;

    paginaAtual: number = 1;
    pagina: number = 1;

    ngOnInit() {
        this.carregarUsuarios();
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {
        if (this.novoEventoPermissoes != undefined) {
            this.permissoes = new EventoPermissoes();
            this.permissoes = this.novoEventoPermissoes;
            this.parmPermissoes = this.novoEventoPermissoes.parmPermissoes;
            this.permissoesAdicionada.emit(this.permissoes);
        }
    }

    finishFunction() {
        if (this.validacaoService.validaEvento(this.eventoLocal)) {
            //limpa campo de parametros
            this.selectedRange = '';
            this.eventoSelecionado = false;
            this.eventoAlterado.emit(true);
            this.wizard.navigation.reset();
        }
    }

    carregarUsuarioSelecionado() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'selecionaAutomatico': true}, 'Selecionar Tipo Cliente', 'Fechar').subscribe(cliente => {

            if (cliente != null) {
                this.cliente = cliente;
                switch (cliente.codTipoCliente) {
                    case 1:
                        this.usuarioSelecionado = this.cliente.userAplicacao.nomeUserAplicacao;
                        break;
                    case 2:
                        this.usuarioSelecionado = this.cliente.mci.nomeCliente;
                    case 3:
                        this.usuarioSelecionado = this.cliente.uor.nomeDependencia;
                    default:
                        return;
                }
            }

            for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
                if (this.evento.permissaoUsoEvento[i]) {
                    if (this.evento.permissaoUsoEvento[i].nomeUserAplicacao == this.usuarioSelecionado) {
                        this.mensagemAlertaUsuario();
                        return;
                    }
                }
            }

            this.permissoesAdicionada.emit({permissaoUsoEvento: this.evento.permissaoUsoEvento, cliente: this.cliente});

        });
    }

    mensagemAlertaUsuario() {
        $.confirm({
            title: 'Atenção!',
            content: 'Usuário já selecionado!',
            type: 'red',
            buttons: {
                ok: {
                    btnClass: 'btn-blue'
                }
            },
            onClose: () => {
            }
        });
    }

    montarUserAplicacaoExtra() {
        if (this.clienteAutorizacaoExtra.userAplicacao) {
            for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
                if (this.usuarioSelecionado) {
                    if (this.evento.permissaoUsoEvento[i]) {
                        if (this.clienteAutorizacaoExtra.userAplicacao.nomeUserAplicacao == this.usuarioSelecionado) {
                            this.mensagemAlertaUsuario();
                            return false;
                        }
                    }
                }
                if (this.evento.permissaoUsoEvento[i]) {
                    if (this.evento.permissaoUsoEvento[i].codUserAplicacao) {
                        if (this.evento.permissaoUsoEvento[i].codUserAplicacao == this.clienteAutorizacaoExtra.userAplicacao.codUserAplicacao) {
                            this.mensagemAlertaUsuario();
                            return false;
                        }
                    } else if (this.evento.permissaoUsoEvento[i].chaveAcesso) {
                        if (this.evento.permissaoUsoEvento[i].chaveAcesso == this.clienteAutorizacaoExtra.userAplicacao.chaveAcesso) {
                            this.mensagemAlertaUsuario();
                            return false;
                        }
                    }
                }
            }

            this.evento.permissaoUsoEvento.push(Object.assign(this.clienteAutorizacaoExtra.userAplicacao, {codTipoCliente: this.clienteAutorizacaoExtra.codTipoCliente}));
            this.permissoesAdicionada.emit({permissaoUsoEvento: this.evento.permissaoUsoEvento, cliente: this.cliente});
        }
    }

    montarUserUorExtra() {
        let clienteAplicacaoUor = {
            'codUserAplicacao': '',
            'versaoUserAplicacao': '',
            'nomeUserAplicacao': this.clienteAutorizacaoExtra.uor.nomeDependencia,
            'codMci': null,
            'codUor': this.clienteAutorizacaoExtra.uor.codUor,
            'chaveAcesso': null
        };

        for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
            if (this.usuarioSelecionado) {
                if (this.usuarioSelecionado) {
                    if (this.clienteAutorizacaoExtra.userAplicacao.nomeUserAplicacao == this.usuarioSelecionado) {
                        this.mensagemAlertaUsuario();
                        return false;
                    }
                }
            }
            if (this.evento.permissaoUsoEvento[i]) {
                if (this.evento.permissaoUsoEvento[i].codUor) {
                    if (this.evento.permissaoUsoEvento[i].codUor == this.clienteAutorizacaoExtra.uor.codUor) {
                        this.mensagemAlertaUsuario();
                        return false;
                    }
                }
            }
        }


        this.evento.permissaoUsoEvento.push(Object.assign(clienteAplicacaoUor, {codTipoCliente: this.clienteAutorizacaoExtra.codTipoCliente}));
        this.permissoesAdicionada.emit({permissaoUsoEvento: this.evento.permissaoUsoEvento, cliente: this.cliente});
    }

    montarUserMciExtra() {
        let clienteAplicacaoMci = {
            'codUserAplicacao': '',
            'versaoUserAplicacao': '',
            'nomeUserAplicacao': this.clienteAutorizacaoExtra.mci.nomeCliente,
            'codMci': this.clienteAutorizacaoExtra.mci.codMci,
            'codUor': null,
            'chaveAcesso': null
        };

        for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
            if (this.usuarioSelecionado) {
                if (this.usuarioSelecionado) {
                    if (this.clienteAutorizacaoExtra.userAplicacao.nomeUserAplicacao == this.usuarioSelecionado) {
                        this.mensagemAlertaUsuario();
                        return false;
                    }
                }
            }
            if (this.evento.permissaoUsoEvento[i]) {
                if (this.evento.permissaoUsoEvento[i].codMci) {
                    if (this.evento.permissaoUsoEvento[i].codMci == this.clienteAutorizacaoExtra.mci.codMci) {
                        this.mensagemAlertaUsuario();
                        return false;
                    }
                }
            }
        }

        this.evento.permissaoUsoEvento.push(Object.assign(clienteAplicacaoMci, {codTipoCliente: this.clienteAutorizacaoExtra.codTipoCliente}));
        this.permissoesAdicionada.emit({permissaoUsoEvento: this.evento.permissaoUsoEvento, cliente: this.cliente});
    }

    carregarClienteAutorizacaoExtra() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {
            'selecionaAutomatico': true,
            'matricula': true
        }, 'Selecionar Tipo Cliente', 'Fechar').subscribe(cliente => {
            if (cliente != null) {
                this.clienteAutorizacaoExtra = cliente;
                switch (this.clienteAutorizacaoExtra.codTipoCliente) {
                    case 1:
                        this.montarUserAplicacaoExtra();
                        break;
                    case 2:
                        this.montarUserMciExtra();
                    case 3:
                        this.montarUserUorExtra();
                    case 4:
                        this.montarUserAplicacaoExtra();
                        break;
                    default:
                        return;
                }
            }

        });
    }

    cancelarEvento() {
        //limpa campo de parametros
        this.selectedRange = '';
        this.eventoSelecionado = false;
        this.eventoCancelado.emit(this.evento);
    }

    removerAutorizacaoExtraUsersSelecionado(cod: number) {
        var lista = [];

        if (this.evento.permissaoUsoEvento.length <= 1) {
            this.evento.permissaoUsoEvento.length = 0;
        }

        for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
            if (this.evento.permissaoUsoEvento[i]) {
                if (this.evento.permissaoUsoEvento[i].codUserAplicacao != cod) {
                    lista.push(this.evento.permissaoUsoEvento[i]);
                }
            }
        }

        this.evento.permissaoUsoEvento.length = 0;
        this.evento.permissaoUsoEvento = lista;
    }

    removerAutorizacaoExtraUsersSelecionadoChave(chave: number) {
        var lista = [];

        if (this.evento.permissaoUsoEvento.length <= 1) {
            this.evento.permissaoUsoEvento.length = 0;
        }

        for (let i = 0; i <= this.evento.permissaoUsoEvento.length; i++) {
            if (this.evento.permissaoUsoEvento[i]) {
                if (this.evento.permissaoUsoEvento[i].chaveAcesso != chave) {
                    lista.push(this.evento.permissaoUsoEvento[i]);
                }
            }
        }

        this.evento.permissaoUsoEvento.length = 0;
        this.evento.permissaoUsoEvento = lista;
    }

    onSubmit(f: NgForm) {
        f.reset();
    }

    getTipoCliente(user: any) {
        if (user.codTipoCliente) {
            switch (user) {
                case 1:
                    return 'Usuário Impessoal';
                case 2:
                    return 'MCI';
                case 3:
                    return 'UOR';
                case 4:
                    return 'Matrícula';
            }
        }

        if (user.codMci) {
            return 'MCI';
        } else if (user.codUor) {
            return 'UOR';
        } else if (user.chaveAcesso) {
            return 'Matrícula';
        } else {
            return 'Usuário Impessoal';
        }

    }

    carregarUsuarios() {
        let usuarioPesquisa: UsuarioPesquisa = new UsuarioPesquisa();
        let filtroUsuarioAplicacao: FiltroUsuarioAplicacao = new FiltroUsuarioAplicacao();
        filtroUsuarioAplicacao.filtros = new Array<UsuarioPesquisa>();
        let filtroAlteracaoEstado: FiltroAlteracaoEstado = new FiltroAlteracaoEstado();
        this.globalService.loading = true;
        let objectSize = Object.keys(usuarioPesquisa).length;

        if (Object.keys(usuarioPesquisa).length > 0) {
            filtroUsuarioAplicacao.filtros.push(usuarioPesquisa);
        }

        filtroUsuarioAplicacao.filtroAlteracaoEstado = filtroAlteracaoEstado;

        let url = this.globalService.getConfiguracao().api_autorizador + '/usuario/filtra';

        let data = JSON.stringify(
            {
                'metadata': {'pagina': this.paginaAtual, 'porPagina': this.pagina},
                'filtros': filtroUsuarioAplicacao.filtros,
                'filtroAlteracaoEstado': filtroUsuarioAplicacao.filtroAlteracaoEstado

            });
        this.globalService.loading = true;

        this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}}).toPromise()
            .then(
                response => {
                    this.globalService.loading = false;
                    this.resultadoUsuario = response;
                    this.pesquisado = true;
                }
            ).catch(
            error => {
                this.globalService.loading = false;
                this.pesquisado = true;
                this.resultadoUsuario = [];
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/detalhe-evento-permissoes/detalhe-evento-permissoes.component.ts